(() => {
  const root = document.querySelector("[data-bioluma-pdp]");
  if (!root) return;

  const currency = root.dataset.currency || "BRL";
  const variantId = root.dataset.variantId;
  const cartAddUrl = (root.dataset.cartAddUrl || "/cart/add").replace(/\.js$/, "") + ".js";

  const toast = root.querySelector("[data-toast]");
  const priceEl = root.querySelector("[data-price]");
  const compareEl = root.querySelector("[data-compare]");
  const ctaPriceEl = root.querySelector("[data-cta-price]");
  const qtyInput = root.querySelector("[data-qty-input]");
  const addBtn = root.querySelector("[data-add-to-bag]");
  const plans = [...root.querySelectorAll(".plan")];
  const planInputs = [...root.querySelectorAll('input[name="bioluma-plan"]')];
  const mainImg = root.querySelector("[data-gallery-main]");
  const thumbs = [...root.querySelectorAll("[data-gallery-thumb]")];
  const accordionItems = [...root.querySelectorAll(".accordion__item")];

  let toastTimer;

  function formatMoney(cents) {
    const amount = (Number(cents) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency,
    });
    return amount;
  }

  function showToast(message) {
    if (!toast) return;
    toast.hidden = false;
    toast.textContent = message;
    toast.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove("is-on"), 1800);
  }

  function syncPlanUI(input) {
    plans.forEach((plan) => {
      plan.classList.toggle("is-selected", plan.contains(input));
    });

    const price = Number(input.dataset.price);
    const compare = input.dataset.compare;
    const qty = Number(input.dataset.qty || input.value || 1);

    if (priceEl) priceEl.textContent = formatMoney(price);
    if (ctaPriceEl) ctaPriceEl.textContent = formatMoney(price);
    if (qtyInput) qtyInput.value = String(qty);

    if (compareEl) {
      if (compare) {
        compareEl.textContent = formatMoney(Number(compare));
        compareEl.classList.remove("is-hidden");
      } else {
        compareEl.textContent = "";
        compareEl.classList.add("is-hidden");
      }
    }
  }

  planInputs.forEach((input) => {
    input.addEventListener("change", () => syncPlanUI(input));
  });

  const checked = planInputs.find((input) => input.checked);
  if (checked) syncPlanUI(checked);

  async function addToCart() {
    if (!variantId || !addBtn) return;

    const selected = planInputs.find((input) => input.checked);
    const quantity = Number(selected?.dataset.qty || qtyInput?.value || 1);
    const label = selected?.dataset.label || "produto";

    addBtn.disabled = true;

    try {
      const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", String(quantity));

      if (cart?.getSectionsToRender) {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.id).join(",")
        );
        formData.append("sections_url", window.location.pathname);
      }

      const response = await fetch(cartAddUrl, {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        showToast(data.description || data.message || "Não foi possível adicionar");
        return;
      }

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "bioluma-pdp",
          productVariantId: variantId,
          cartData: data,
        });
      }

      if (cart?.renderContents) {
        try {
          cart.renderContents(data);
        } catch (renderError) {
          // Se o drawer falhar ao re-renderizar, ainda tenta abrir
          if (typeof cart.open === "function") cart.open(addBtn);
        }
      } else if (typeof cart?.open === "function") {
        cart.open(addBtn);
      }

      showToast(`${label} adicionado à sacola`);
    } catch (error) {
      showToast("Erro ao adicionar à sacola");
    } finally {
      addBtn.disabled = false;
    }
  }

  addBtn?.addEventListener("click", (event) => {
    event.preventDefault();
    addToCart();
  });

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      if (!mainImg) return;
      mainImg.src = thumb.dataset.src;
      mainImg.alt = thumb.dataset.alt || "";
      thumbs.forEach((item) => {
        const active = item === thumb;
        item.classList.toggle("is-active", active);
        item.setAttribute("aria-current", active ? "true" : "false");
      });
    });
  });

  accordionItems.forEach((item) => {
    item.addEventListener("toggle", () => {
      if (!item.open) return;
      accordionItems.forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });

  const reviewsLink = root.querySelector("[data-reviews-link]");
  const reviewsPanel = document.getElementById("avaliacoes");

  reviewsLink?.addEventListener("click", (event) => {
    event.preventDefault();
    reviewsPanel?.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  const desc = root.querySelector("[data-desc]");
  const descText = root.querySelector("[data-desc-text]");
  const descToggle = root.querySelector("[data-desc-toggle]");

  if (desc && descText && descToggle) {
    const needsToggle = descText.scrollHeight > descText.clientHeight + 2;
    if (needsToggle) {
      descToggle.hidden = false;
      descToggle.addEventListener("click", () => {
        const expanded = desc.classList.toggle("is-expanded");
        descToggle.textContent = expanded ? "Veja menos" : "Veja mais";
      });
    }
  }
})();
